export const osnTop104SIcon = {
  data: `<svg viewBox="0 0 280 210" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.5"
d="M166.08 203V164.36H190.16V129.36H166.08V16.24H111.2L37 133V164.36H126.32V203H166.08ZM126.32 129.36H75.92L126.32
 51.52V129.36Z" fill="#0F0125" stroke="currentColor" stroke-width="13"/></svg>`,
  name: 'top-10-4-s',
};
